import React from 'react';
import {Link} from 'react-router-dom';
import Avatar from './Avatar';
import DateSince from './Date';
import Views from './Views';
import Answers from './Answers';
import pictureLogo from '../../images/logo.png';
import createLink from "../../libs/createLink";
import Like from "./Like/Like";
import Dotdotdot from "react-dotdotdot";
import Icon from "./Icon";
import {isNoFollowArticle, isNoFollowProfil} from "../../libs/helper";


const ArticleCardSmall = (props) => {
    let title = props.title || " ";

    let link = createLink('article', {...props.owner, article : {_id : props._id, slug : props.slug}});
    let relLink = isNoFollowArticle(props) ? { rel: "nofollow" } : {};
    let relLinkProfil = isNoFollowProfil(props.owner) ? { rel: "nofollow" } : {};
    let hasOwner = props.owner !== null && props.owner._id;

    return (
        <div className="card-article-small">
            {(!props.isOpened || props.right === "private" || props.right === "privateclub") &&
                <div className={"card-information"}>
                    {props.isOpened && props.right === "private" && (
                        <Icon type={"user"} />
                    )}
                    {props.isOpened && props.right === "privateclub" && (
                        <Icon type={"group"} />
                    )}
                    {!props.isOpened && (
                        <Icon type={"lock"} />
                    )}
                </div>
            }
            <div className="wrapper">
                <div className="content">
                    <div>
                        <Link to={link} className="column flex-1" {...relLink}>
                            {props.cover.length ? (
                                <div className="article-img">
                                    <img
                                        loading="lazy"
                                        src={`${props.cover}?width=350&height=200&quality=100`}
                                        alt={""}/>
                                </div>
                            ) : (
                                <div className="article-img">
                                    <div className="title-link-articles">
                                        <img className={"no-illustration"} loading="lazy" src={pictureLogo} alt=""/>
                                        <span className="text medium-grey">Cet article n'a pas d'illustration</span>
                                    </div>
                                </div>
                            )}
                            <div className="topline py-8 px-16">
                                <div className="title-link-articles">
                                    <Dotdotdot tagName="h3" clamp={2} useNativeClamp={false}>
                                        {title}
                                    </Dotdotdot>
                                </div>
                                <span className="text small medium-grey py-4 badge dark">
                                    {props.status ? (
                                        <DateSince
                                            date={props.createdAt}
                                            prefix={true}
                                            currentFormat={true}
                                        />
                                    ) : (
                                        "Brouillon"
                                    )}
                                </span>
                            </div>
                        </Link>
                        <div className={`excerpt`}>
                            <Dotdotdot clamp={"4"} useNativeClamp={false}>
                                {props.excerpt}
                            </Dotdotdot>
                        </div>
                    </div>
                    {hasOwner ? (<div className="user">
                        <Link className="mr-16" to={createLink("userProfile", props.owner)} {...relLinkProfil}>
                            <Avatar className="user-thumb"
                                    avatar={props.owner.profile.avatar && props.owner.profile.avatar}
                                    gender={props.owner.profile.gender} alt="" width={30} height={30}/>
                        </Link>
                        <div className="infos">
                            <div className="username-time">
                                <Link to={createLink("userProfile", props.owner)} {...relLinkProfil}>
                                {props.owner.username}&nbsp;
                            </Link>
                            </div>
                        </div>
                    </div>) : (<div className="user">
                            <div className="mr-16">
                                <Avatar className="user-thumb" gender={"guest"} alt=""/>
                            </div>
                            <div className="infos">
                                <div className="username-time">
                                    Par &nbsp; {props.authorName}
                                </div>
                            </div>
                        </div>
                    )}
                </div>
                <div className="footer">
                    <Views type="icon" value={props.count && (props.count.view || 0)}/>
                    <Answers value={props.count && (props.count.comment || 0)}/>

                    {props._id && <Like isLiked={props.isLiked}
                                        value={props.count.like || 0}
                                        likeType={props.likeType}
                                        parentId={props._id}
                    />}
                </div>
            </div>
        </div>
    )
};

ArticleCardSmall.defaultProps = {
    title: "",
    slug: "",
    _id: 0,
    count: {
        like: 0,
        view: 0,
        comment: 0
    },
    blog: {
        _id: 0,
        title: '',
        slug: '',
    },
    filename: {
        url: ""
    },
    owner: {
        _id: 0,
        gender: "",
        slug: '',
        username: '',
        profile: {
            avatar: "",
            gender: "",
        }
    },
    isStory: false,
    authorName: ""
};

export default ArticleCardSmall;
